export function getNavLoadingIndicator(
  loadingSpinnerColor = '#000'
): HTMLDivElement {
  const navLoadingIndicator = document.createElement('div');
  navLoadingIndicator.id = 'chameleon-nav-loading-indicator';
  navLoadingIndicator.style.position = 'fixed';
  navLoadingIndicator.style.left = '0px';

  navLoadingIndicator.style.top = '0px';
  navLoadingIndicator.style.width = '100vw';
  navLoadingIndicator.style.height = '100vh';

  navLoadingIndicator.style.display = 'flex';
  navLoadingIndicator.style.justifyContent = 'center';
  navLoadingIndicator.style.alignItems = 'center';

  [0, 1, 2].forEach(_ => {
    const loadingSpinnerChild = document.createElement('div');
    (loadingSpinnerChild.style.backgroundColor = loadingSpinnerColor),
      navLoadingIndicator.appendChild(loadingSpinnerChild);
  });

  navLoadingIndicator.classList.add('la-ball-pulse', 'la-dark');

  return navLoadingIndicator;
}
